/**
 * Project : workspace
 * File    : ErrorSuggestion.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package component

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import theme.ThemeColor

@Composable
/**
 * Executes the error suggestion operation.
 *
 * @receiver TODO
 * @param message The message.
 * @return Unit – no return value.
 */
fun ErrorSuggestion(message: String) {
    Row(
        modifier = Modifier
            .fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(
            space = 10.dp,
        ),
        verticalAlignment = Alignment.CenterVertically
    ) {
//        Image(painter = painterResource(id = R.drawable.error), contentDescription = "Error Icon")
        Text(text = message, color = ThemeColor.shared().TextColor, fontSize = 14.sp)
    }
}